import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {showPaymentErrorAlert, showServerErrorAlert} from '../../actions/error.action';
import AppModal from '../../components/Modal/AppModal';
import {errorStyles} from './modal.config';
import Error from '../Error/Error';
import {CORRUPTED_BASKET} from '../../constants/errorCodes';

class ErrorModal extends PureComponent {
  constructor(props) {
    super(props);
    this.resetErrors = this.resetErrors.bind(this);
  }

  resetErrors() {
    const {errors} = this.props;
    if (errors.server === CORRUPTED_BASKET) {
      this.props.setServerError(false);
      this.props.setPaymentError(false);
      return location.href = '/menu';
    }
    if (!errors.payment) {
      location.reload();
    }
    this.props.setServerError(false);
    this.props.setPaymentError(false);
  }

  render() {
    const {errors} = this.props;
    const errorMessage = errors.server ? 'error.refresh' : (errors.payment ? 'error.payment' : 'error.item.refresh');

    return (
      (errors.server || errors.item || errors.payment) &&
      <AppModal
        customStyles={errorStyles}
        callback={this.resetErrors}
      >
        <Error
          callback={this.resetErrors}
          message={errorMessage}
        />
      </AppModal>
    );
  }
}

ErrorModal.propTypes = {
  setServerError: PropTypes.func.isRequired,
  setPaymentError: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    errors: state.errors
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setServerError: bindActionCreators(showServerErrorAlert, dispatch),
    setPaymentError: bindActionCreators(showPaymentErrorAlert, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);



// WEBPACK FOOTER //
// ./components/Modal/ErrorModal.js